import React, { Component } from 'react';
import { withTranslation } from 'react-i18next'; 
// Basic Components
import DecimalInput from 'screens/components/basic/DecimalInput';
import Button from 'screens/components/basic/Button';
import DialogHeader from 'screens/components/basic/DialogHeader';
// Advanced Components
import DialogInput from 'screens/components/advanced/DialogInput';

const dialogStyle = {
    width: '65%',
    maxWidth: 'none'
};


class POSAddShippingCostDialog extends Component {
    constructor(props, context) {
        super(props, context);
    }

    render(){
        const { t } = this.props;
        const p = this.props;
        return (
            <div>
                <DialogInput
                    title={<DialogHeader text={t('pos.addShippingCostDialog.addCost', { id: p.orderId })} />}
                    modal={true}
                    open={p.open}
                    autoScrollBodyContent={true}
                    contentStyle={dialogStyle}
                    actions={[
                        <Button
                            key={2}
                            type="CancelButton"
                            name="buttonCancel"
                            className="btn-space"
                            label={t('common.cancel')}
                            onTouchTap={() => this.props.onClose()} />,
                        <Button
                            key={1}
                            name="addButton"
                            label={t('common.apply')}
                            primary={true}
                            onTouchTap={() => this.props.addShippingCost()} />
                    ]}>
                        <div className="row">
                            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                                <DecimalInput name={`${p.name}Value`}
                                    fullWidth={true}
                                    label={t('pos.addShippingCostDialog.shippingCost')}
                                    floatingLabelText={t('pos.addShippingCostDialog.shippingCost')}
                                    hintText={t('pos.addShippingCostDialog.shippingCost')}
                                    min={0}
                                    />
                            </div>
                        </div>
                </DialogInput>
            </div>
        )
    }
}

export default withTranslation()(POSAddShippingCostDialog);
